<template>
  <ModalDialog :show="show" @closed="$emit('closed')">
    <template v-slot:title>
      <slot name="title" />
    </template>
    <div class="sf-modal-body">
      <div v-if="step == 'main'">
        <h2>Print Word List</h2>
        <h4 class="tw-mb-4">Select the list format</h4>
        <div class="[&>*]:tw-mb-2">
          <button
            class="sf-btn-primary tw-w-full"
            @click.prevent="step = 'segmented'"
          >
            Segmented word list
          </button>
          <button
            class="sf-btn-primary tw-w-full"
            @click.prevent="step = 'cursive'"
          >
            Cursive word list
          </button>
          <a class="sf-btn-primary tw-w-full" :href="baseUrl + '&md=2'">
            Trace word list
          </a>
          <button
            class="sf-btn-primary tw-w-full"
            @click.prevent="step = 'sentences'"
          >
            Sentences (fill in the missing words)
          </button>
          <a class="sf-btn-primary tw-w-full" :href="baseUrl + '&md=4'">
            Look, cover, write
          </a>
        </div>
      </div>
      <div
        v-else-if="step == 'sentences'"
        class="tw-grid tw-grid-cols-2 tw-gap-2"
      >
        <a :href="baseUrl + '&md=3&sw=1'" class="sf-btn-primary tw-w-full">
          Show word list
        </a>
        <a :href="baseUrl + '&md=3&sw=0'" class="sf-btn-primary tw-w-full">
          Do not show word list
        </a>
      </div>
      <div v-else>
        <h4>Select font size</h4>
        <div class="tw-grid tw-grid-cols-2 tw-gap-2">
          <a
            class="sf-btn-primary tw-w-full"
            :href="baseUrl + '?md=1&ff=' + stepMode + '&fs=1'"
          >
            Very Small
          </a>
          <a
            class="sf-btn-primary tw-w-full"
            :href="baseUrl + '?md=1&ff=' + stepMode + '&fs=2'"
          >
            Small
          </a>
          <a
            class="sf-btn-primary tw-w-full"
            :href="baseUrl + '?md=1&ff=' + stepMode + '&fs=3'"
          >
            Medium
          </a>
          <a
            class="sf-btn-primary tw-w-full"
            :href="baseUrl + '?md=1&ff=' + stepMode + '&fs=4'"
          >
            Large
          </a>
        </div>
      </div>
    </div>
    <div class="sf-modal-footer">
      <button class="sf-btn-primary" @click.prevent="$emit('close')">
        Done
      </button>
      <button
        v-if="step != 'main'"
        class="sf-btn-secondary"
        @click.prevent="step = 'main'"
      >
        Back
      </button>
    </div>
  </ModalDialog>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import ModalDialog from "../ui/ModalDialog.vue";

export default defineComponent({
  components: { ModalDialog },
  props: {
    show: Boolean,
    testId: Number,
    categoryId: Number,
    listId: Number,
    trickyWords: Boolean,
  },
  emits: ["close", "closed"],
  data() {
    return {
      step: "main" as "main" | "segmented" | "cursive" | "sentences",
    };
  },
  computed: {
    baseUrl(): string {
      const path = "/pdf/word-list?";
      if (this.testId) {
        return path + "test_id=" + this.testId;
      } else if (this.categoryId) {
        return path + "cat=" + this.categoryId;
      } else if (this.listId) {
        return path + "list_id=" + this.listId;
      } else if (this.trickyWords) {
        return path + "tricky_words=1";
      }
      return "";
    },
    stepMode(): number {
      return this.step == "cursive" ? 2 : 1;
    },
  },
});
</script>
